export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <svg className="brand-mark" width={size} height={size} viewBox="0 0 64 64" role="img" aria-labelledby="brand-mark-title">
      <title id="brand-mark-title">열린 골목문과 이어지는 길</title>
      <path className="brand-mark__gate" d="M12 8h40v8h-4v39h-9V25H25v30h-9V16h-4z" />
      <path className="brand-mark__route" d="M4 43h23v-3l14 7-14 7v-3H4z" />
    </svg>
  );
}
